import { useState } from "react";
import "./TooltipUI.css";

const TooltipUIViewOnly = ({ children, text }) => {
  const [show, setShow] = useState(false);

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && text && (
        <div className="tooltipviewonly">
          {text}
          <span className="tooltip-arrowviewonly" />
        </div>
      )}
    </div>
  );
};

export default TooltipUIViewOnly;